<template>
    <div class="p14">
        <div class="flex jcsb m-b9">
            <div class="flex" >
                <el-date-picker class="" :clearable="false" size="mini" v-model="month" type="month" placeholder="选择月" format="yyyy-MM" value-format="yyyy-MM" @change="changeMonth"></el-date-picker>

                <span class="datetxt m-l14">姓名:</span>
                <el-input
                        style="width: 220px"
                        size="mini"
                        class="input"
                        placeholder="搜索人名"
                        v-model="search"
                        clearable>
                </el-input>

<!--                <el-select @change="kqdataChange"  class="m-l14"  style="width:120px;" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">-->
<!--                    <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>-->
<!--                </el-select>-->
                <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>

                <el-button  class="m-l14" :class="baseerp+'btn'"  size="mini" @click="eidtYcFun()" type="primary">查看</el-button>

            </div>
            <div>
                <el-button :class="baseerp+'btn'" :disabled="!month" type="primary" size="mini" @click="eidtFun('new')">新增</el-button>
            </div>
        </div>
        <el-table  ref="table" :header-cell-style="{background:'#f5f7fa',color:'#000'}" size="mini" :height="tableHeight" border  :data="tableData" style="width: initial;">
            <!--            <el-table-column type="selection" align="center"></el-table-column>-->
            <!--            <el-table-column align="center" label="日期" prop="forDate">-->
            <!--                <template class="flex"  slot-scope="scope">-->
            <!--                    <el-date-picker class="m-l14" size="mini" v-model="scope.row.date" type="month" placeholder="选择日" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>-->

            <!--                </template>-->
            <!--            </el-table-column>-->
            <el-table-column
                    :label="$t('form_serial_number')"
                    align="center"
                    type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" width="80" label="所属月份" prop="dt_formonth" show-overflow-tooltip></el-table-column>

            <el-table-column align="center" label="状态" prop="confirmedTxt" width="80">
                <template class="flex"  slot-scope="scope">
                    <span :class="(scope.row.i_state==-1||scope.row.i_state==-2)?'red':(scope.row.i_state==0)?'blue':'green'">{{scope.row.vc_state}}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="附件" show-overflow-tooltip>
                <template class="flex"  slot-scope="scope" v-if="scope.row.vc_filename">
                    <a
                            download="下载附件"
                            mce_href="#"
                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_filenewname+',attendence\'}','utf-8')">
                            {{scope.row.vc_filename}}
                    </a>
                </template>
            </el-table-column>
            <el-table-column align="center" label="识别码" prop="vc_code"  show-overflow-tooltip></el-table-column>
<!--            <el-table-column align="center" label="补卡附件" show-overflow-tooltip>-->
<!--                <template class="flex"  slot-scope="scope" v-if="scope.row.vc_bk_filename">-->
<!--                    <a-->
<!--                            download="下载附件"-->
<!--                            mce_href="#"-->
<!--                            :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_bk_filenewname+',attendence\'}','utf-8')">-->
<!--                            {{scope.row.vc_bk_filename}}-->
<!--                    </a>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column align="center" label="补卡识别码" prop="vc_bk_code"  show-overflow-tooltip></el-table-column>-->
            <el-table-column align="center" label="异常条目" prop="i_hasexcept" width="70" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="录入人" prop="vc_lruname"width="70"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="录入时间" prop="dt_createtime"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="受理人" prop="vc_approve_uname" width="70" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="受理时间" prop="dt_approvetime" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作(保存后生效)" width="150" >
                <template class="flex"  slot-scope="scope">
                    <el-button type="text"   @click="eidtFun('edit',scope.row)">查看详情</el-button>
                    <el-button type="text"  @click="flowSub(scope.row)">生成附件</el-button>
<!--                    <el-button type="text" v-if="scope.row.i_state==1"  @click="flowSubBk(scope.row)">生成补卡附件</el-button>-->

                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="95%"
                       top="30px"
                       :visible.sync="dialogSub"
                       :close-on-click-modal="false"
                       @close="closeSubFun">

                <sub-list :data="propData" v-if="dialogSub" @close="closeSubFun" ></sub-list>
            </el-dialog>
            <el-dialog title="查看异常"
                       width="95%"
                       top="30px"
                       :visible.sync="ycdialogSub"
                       :close-on-click-modal="false"
                       @close="closeYcFun">

                <yc-index :data="ycData" v-if="ycdialogSub" @close="closeYcFun" ></yc-index>
            </el-dialog>
        </div>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"   ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import SubList from './SubIndex'
    import YcIndex from './YcIndex'
    import {mapActions} from "vuex";
    const getYm=()=>{
        let newD=new Date();
        let y=newD.getFullYear();
        let m=newD.getMonth()+1;
        m=m>9? m : '0'+m;
        return y+'-'+m
    };
    export default {

        name: "jiaBan",
        components:{
            eDialog,
            reportdialog,
            SubList,YcIndex
        },
        data(){
            return{
                baseerp:baseerp,
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:baseApp,
                baseVersion:baseVersion,
                searchname:'',
                searchPeople:[],
                month:'',
                personid:null,
                disabled:false,
                tableHeight:0,//列表高度
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                canEdit:false,
                canSave:false,
                dialogSub:false,
                ycdialogSub:false,
                delList:[],
                activePage:"report/res/spread.vue",
                djmark:'',//考勤方案
                kaoqinList:[],
                kaoqini_id:0,
                kqdata:'',
                propData:{},
                ycData:{},
                title:'查看',
                search:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.overtimeList()
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },



            //名称搜索
            searchFun(val){
                this.currentPage=1
                this.overtimeList()
                this.$forceUpdate()
            },
            changeMonth(){
                this.currentPage=1
                this.canSave=false
                this.canEdit=false
                this.overtimeList()
            },
            eidtFun(type='new',row={}){
                if (type=='new'){
                    this.dialogSub=true
                    this.propData={
                        i_id:0,
                        dt_formonth:this.month,
                        vc_filenewname:'',
                        vc_bk_filenewname:'',
                    }
                }else{
                    this.dialogSub=true
                    this.propData=row


                }
            },
            eidtYcFun(){
                this.ycdialogSub=true
                this.ycData={
                    type:'kan',
                    i_id:0,
                    dt_formonth:this.month,
                    vc_filenewname:'',
                    vc_bk_filenewname:'',
                }
            },
            closeSubFun(type='back'){
                if(type=='save'){
                    this.currentPage=1;
                    //调用列表接口
                    this.overtimeList();
                    this.propData={}
                }
                this.propData={}
                this.dialogSub=false
            },
            closeYcFun(type='back'){
                if(type=='save'){
                    this.currentPage=1;
                    //调用列表接口
                    this.overtimeList();
                    this.ycData={}
                }
                this.ycData={}
                this.ycdialogSub=false
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.overtimeList();

            },
            async overtimeList(){
                let param={
                    currentPage:this.currentPage,
                    pageSize: this.pageSize,
                    vc_search:this.search,
                    forMonth:this.month,
                };
                // this.tableData=[{
                //     i_id:1,
                //     vc_state:'通过',
                //     i_state:1,
                //     dt_createtime:'2024-07-24',
                //     vc_filenewname:'',
                // }];
                //
                // return
                let res=await API.getOvertimeSqList(param);
                if(res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
                // }else{
                //     this.$message.warning('请选择产品')
                // }

            },
            kqdataChange(val){
                // console.log(val)
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id

            },
            async workovertime() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.month

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"考勤结果报表",parm:{type:'OvertimeExceptRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
            //考勤方案接口
            async getKqList() {

                let param = {
                    i_mid: this.mid,

                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    this.kaoqinList=res.data
                    this.kqdata=res.data[0].vc_tcname
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    this.kaoqini_id=kqdjmark[0].i_id
                    this.djmark=kqdjmark[0].vc_djmark
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            async flowSub(item){
                this.$confirm(item.vc_filenewname?'是否覆盖已生成的附件':'是否生成附件','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    // this.$message.success('正在提交，请稍候')
                    let param={
                        i_id:item.i_id,
                    };
                    let res=await API.getOvertimeSqPdf(param);
                    if ( res.code == 1 ){
                        this.$message.success(res.message)
                       this.overtimeList()
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })

            },
            async flowSubBk(item){

                this.$confirm(item.vc_bk_filenewname?'是否覆盖已生成的补卡附件':'是否生成补卡附件','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    // this.$message.success('正在提交，请稍候')
                    let param={
                        i_id:item.i_id,
                    };
                    let res=await API.getOvertimeBkPdf(param);
                    if ( res.code == 1 ){
                        this.$message.success(res.message)
                       this.overtimeList()
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }else{
                        this.$message.error(res.message);
                    }
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })

            },
        }
    }
</script>

<style lang="scss" scoped>
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .blue{
        color: dodgerblue;
    }
    .p14{
        padding: 14px;
    }
    .m-l14{
        margin-left: 14px;
    }
    .m-b9{
        margin-bottom: 9px;
    }
    .datetxt{
        font-size: 14px;
        display: inline-block;
        width: 50px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .el-radio{
            margin-right: 15px;
        }
    }
</style>